if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
      Alpine.data('xDeliveryLocation', (settings) => ({
        modalOpen: false,
        confirmOpen: false,
        countryName: settings.countryName,
        countryIso: settings.countryIso,
        usName: settings.usName || 'United States',
        selectedCountryIso: '',
        selectedCountryName: '',
        selectedAddressIndex: -1,
        selectedAddress: null,
        usIso: settings.usIso || 'US',
        storageKey: settings.storageKey || 'eurus_delivery_location',
        form: null,
        countryInput: null,
        designMode: false,
        zip: '',
        zipLoading: false,
        zipMessage: '',
        displayLocation: settings.countryName,
        pendingLocation: null,
        nudgeOpen: false,
        nudgeStorageKey: `${settings.storageKey || 'eurus_delivery_location'}_nudge_seen`,
        nudgeTimer: null,
        nudgeMenuWasOpen: false,
        nudgeFooterObserver: null,
        zipCityPrefixes: {
          '005': 'Holtsville',
          '006': 'San Juan',
          '007': 'San Juan',
          '008': 'Charlotte Amalie',
          '009': 'San Juan',
          '010': 'Springfield',
          '011': 'Springfield',
          '012': 'Pittsfield',
          '013': 'Greenfield',
          '014': 'Fitchburg',
          '015': 'Worcester',
          '016': 'Worcester',
          '017': 'Framingham',
          '018': 'Lowell',
          '019': 'Lynn',
          '020': 'Brockton',
          '021': 'Boston',
          '022': 'Boston',
          '023': 'Brockton',
          '024': 'Newton',
          '025': 'Cape Cod',
          '026': 'Cape Cod',
          '027': 'New Bedford',
          '028': 'Providence',
          '029': 'Providence',
          '030': 'Manchester',
          '031': 'Manchester',
          '032': 'Concord',
          '033': 'Concord',
          '034': 'Keene',
          '035': 'Berlin',
          '036': 'Claremont',
          '037': 'Lebanon',
          '038': 'Portsmouth',
          '039': 'Portsmouth',
          '040': 'Portland',
          '041': 'Portland',
          '042': 'Lewiston',
          '043': 'Augusta',
          '044': 'Bangor',
          '045': 'Bath',
          '046': 'Ellsworth',
          '047': 'Presque Isle',
          '048': 'Rockland',
          '049': 'Waterville',
          '050': 'White River Junction',
          '051': 'Springfield',
          '052': 'Bennington',
          '053': 'Brattleboro',
          '054': 'Burlington',
          '055': 'Andover',
          '056': 'Montpelier',
          '057': 'Rutland',
          '058': 'St. Johnsbury',
          '059': 'Canaan',
          '060': 'Hartford',
          '061': 'Hartford',
          '062': 'Willimantic',
          '063': 'New London',
          '064': 'New Haven',
          '065': 'New Haven',
          '066': 'Bridgeport',
          '067': 'Waterbury',
          '068': 'Stamford',
          '069': 'Stamford',
          '070': 'Newark',
          '071': 'Newark',
          '072': 'Elizabeth',
          '073': 'Jersey City',
          '074': 'Paterson',
          '075': 'Paterson',
          '076': 'Hackensack',
          '077': 'Red Bank',
          '078': 'Dover',
          '079': 'Morristown',
          '080': 'Camden',
          '081': 'Camden',
          '082': 'Atlantic City',
          '083': 'Vineland',
          '084': 'Atlantic City',
          '085': 'Trenton',
          '086': 'Trenton',
          '087': 'Toms River',
          '088': 'New Brunswick',
          '089': 'New Brunswick',
          '090': 'Military Mail',
          '091': 'Military Mail',
          '092': 'Military Mail',
          '093': 'Military Mail',
          '094': 'Military Mail',
          '095': 'Military Mail',
          '096': 'Military Mail',
          '097': 'Military Mail',
          '098': 'Military Mail',
          '099': 'Military Mail',
          '100': 'New York',
          '101': 'New York',
          '102': 'New York',
          '103': 'Staten Island',
          '104': 'Bronx',
          '105': 'White Plains',
          '106': 'White Plains',
          '107': 'Yonkers',
          '108': 'New Rochelle',
          '109': 'Middletown',
          '110': 'Long Island',
          '111': 'Long Island City',
          '112': 'Brooklyn',
          '113': 'Queens',
          '114': 'Queens',
          '115': 'Long Island',
          '116': 'Queens',
          '117': 'Long Island',
          '118': 'Long Island',
          '119': 'Long Island',
          '900': 'Los Angeles',
          '901': 'Los Angeles',
          '902': 'Los Angeles',
          '903': 'Inglewood',
          '904': 'Santa Monica',
          '905': 'Torrance',
          '906': 'Los Angeles',
          '907': 'Long Beach',
          '908': 'Long Beach',
          '909': 'San Bernardino',
          '910': 'Pasadena',
          '911': 'Pasadena',
          '912': 'Glendale',
          '913': 'San Fernando Valley',
          '914': 'Van Nuys',
          '915': 'Burbank',
          '916': 'North Hollywood',
          '917': 'Pomona',
          '918': 'Alhambra',
          '919': 'San Diego',
          '920': 'San Diego',
          '921': 'San Diego',
          '922': 'Palm Springs',
          '923': 'San Bernardino',
          '924': 'San Bernardino',
          '925': 'Riverside',
          '926': 'Orange County',
          '927': 'Santa Ana',
          '928': 'Anaheim',
          '929': 'San Diego',
          '930': 'Ventura',
          '931': 'Santa Barbara',
          '932': 'Bakersfield',
          '933': 'Bakersfield',
          '934': 'San Luis Obispo',
          '935': 'Lancaster',
          '936': 'Fresno',
          '937': 'Fresno',
          '938': 'Fresno',
          '939': 'Salinas',
          '940': 'San Francisco Bay Area',
          '941': 'San Francisco',
          '942': 'Sacramento',
          '943': 'Palo Alto',
          '944': 'San Mateo',
          '945': 'Oakland',
          '946': 'Oakland',
          '947': 'Berkeley',
          '948': 'Richmond',
          '949': 'Marin County',
          '950': 'San Jose',
          '951': 'San Jose',
          '952': 'Stockton',
          '953': 'Modesto',
          '954': 'Santa Rosa',
          '955': 'Eureka',
          '956': 'Sacramento',
          '957': 'Sacramento',
          '958': 'Sacramento',
          '959': 'Chico',
          '960': 'Redding',
          '961': 'Lake Tahoe'
        },
        init() {
          this.form = this.$el.closest('form');
          this.countryInput = this.form?.querySelector('#currency_selector');
          this.designMode = Boolean(window.EurusThemeEditorMode || window.Shopify?.designMode);
          try {
            const saved = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
            if (!this.designMode && saved.countryIso && saved.countryIso !== this.countryIso && !sessionStorage.getItem(`${this.storageKey}_syncing_country`)) {
              sessionStorage.setItem(`${this.storageKey}_syncing_country`, 'true');
              this.submitCountry(saved.countryIso);
              return;
            }
            sessionStorage.removeItem(`${this.storageKey}_syncing_country`);
            if (this.designMode && saved.countryIso) {
              this.countryIso = saved.countryIso;
              this.displayLocation = this.formatLocationLabel(saved.displayLabel || saved.label || saved.countryName || this.countryName);
              window.dispatchEvent(new CustomEvent('eurus:delivery-location:updated', { detail: saved || {} }));
            } else if (saved.zip && this.countryIso === this.usIso) {
              this.zip = saved.zip;
              this.displayLocation = this.formatLocationLabel(saved.displayLabel || saved.label || saved.zip);
            } else if (saved.type === 'address' && saved.displayLabel) {
              this.displayLocation = this.formatLocationLabel(saved.displayLabel);
            } else if (saved.countryIso && saved.countryIso === this.countryIso && saved.countryName) {
              this.displayLocation = this.formatLocationLabel(saved.countryName);
            }
          } catch (e) {
            this.displayLocation = this.formatLocationLabel(this.countryName);
          }
          if (this.isFooterNudgeContext()) {
            this.initFooterNudgeObserver();
          } else if (!this.isMobileNudgeContext()) {
            this.showNudgeIfNeeded(900);
          }
          this.updateCountryDivider();
        },
        updateCountryDivider() {
          const select = this.$refs.countrySelect;
          const divider = select?.querySelector('[data-country-divider]');
          if (!divider) return;
          const selectWidth = select.getBoundingClientRect().width || 0;
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
          const widthBasis = selectWidth ? Math.min(selectWidth, viewportWidth) : viewportWidth;
          const dividerLength = Math.max(4, Math.min(24, Math.floor(widthBasis / 38)));
          divider.textContent = '\u2500'.repeat(dividerLength);
        },
        isMobileNudgeContext() {
          return Boolean(this.$el.closest('#mobile-navigation') || this.$el.closest('#menu-drawer'));
        },
        isFooterNudgeContext() {
          return Boolean(this.$el.closest('#section-footer'));
        },
        handleNudgeVisibility(mobileNavOpen, menuDrawerOpen) {
          if (!this.isMobileNudgeContext()) return;
          const mobileContextOpen = Boolean(
            this.$el.closest('#mobile-navigation') && mobileNavOpen ||
            this.$el.closest('#menu-drawer') && menuDrawerOpen
          );
          if (mobileContextOpen && !this.nudgeMenuWasOpen) {
            this.nudgeMenuWasOpen = true;
            this.showNudgeIfNeeded(1700);
          } else if (!mobileContextOpen) {
            this.nudgeMenuWasOpen = false;
            this.nudgeOpen = false;
            if (this.nudgeTimer) clearTimeout(this.nudgeTimer);
          }
        },
        initFooterNudgeObserver() {
          if (!this.isFooterNudgeContext()) return;
          if (!window.matchMedia('(max-width: 1023px)').matches) return;
          if (!('IntersectionObserver' in window)) return;
          this.nudgeFooterObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
              this.showNudgeIfNeeded(900);
              this.nudgeFooterObserver?.disconnect();
              this.nudgeFooterObserver = null;
            });
          }, {
            threshold: [0.45]
          });
          this.nudgeFooterObserver.observe(this.$el);
        },
        getNudgeLocationKey() {
          const locationKey = `${this.countryIso || ''}_${this.displayLocation || this.countryName || ''}`
            .toString()
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
          return `${this.nudgeStorageKey}_${locationKey || 'default'}`;
        },
        showNudgeIfNeeded(delay = 900) {
          // Auto-nudge disabled: shoppers change their delivery address themselves via the trigger.
          return;
          const canShowNudge = this.$el.closest('#x-header-container') || this.$el.closest('#mobile-navigation') || this.$el.closest('#menu-drawer') || this.isFooterNudgeContext();
          if (!canShowNudge) return;
          try {
            if (localStorage.getItem(this.getNudgeLocationKey()) === 'true') return;
          } catch (e) {}
          if (this.nudgeTimer) clearTimeout(this.nudgeTimer);
          this.nudgeTimer = setTimeout(() => {
            if (!this.modalOpen && !this.confirmOpen) this.nudgeOpen = true;
          }, delay);
        },
        markNudgeSeen() {
          this.nudgeOpen = false;
          try {
            localStorage.setItem(this.getNudgeLocationKey(), 'true');
          } catch (e) {}
        },
        dismissNudge() {
          this.markNudgeSeen();
        },
        changeAddressFromNudge() {
          this.markNudgeSeen();
          this.open();
        },
        open() {
          this.nudgeOpen = false;
          this.confirmOpen = false;
          this.modalOpen = true;
          Alpine.store('xPopup').open = true;
          Alpine.store('xModal').setActiveElement(this.$el.querySelector('button')?.id || '');
          this.$nextTick(() => {
            this.updateCountryDivider();
            document.getElementById(this.$el.querySelector('[aria-controls]')?.getAttribute('aria-controls'))?.focus();
          });
        },
        close() {
          if (!this.modalOpen) return;
          this.modalOpen = false;
          Alpine.store('xPopup').close();
          if (Alpine.store('xModal').activeElement) Alpine.store('xModal').removeFocus();
        },
        closeConfirm() {
          if (!this.confirmOpen) return;
          this.confirmOpen = false;
          Alpine.store('xPopup').close();
          if (Alpine.store('xModal').activeElement) Alpine.store('xModal').removeFocus();
        },
        openConfirm(location) {
          this.pendingLocation = location;
          this.displayLocation = this.formatLocationLabel(location.displayLabel || location.label || this.displayLocation);
          this.modalOpen = false;
          this.confirmOpen = true;
          Alpine.store('xPopup').open = true;
          this.$nextTick(() => {
            document.getElementById(this.$el.querySelector('[aria-controls]')?.getAttribute('aria-controls')?.replace('Dialog', 'Confirm'))?.focus();
          });
        },
        saveLocation(data) {
          if (data?.type === 'address' && !data.displayLabel) {
            data.displayLabel = this.compactAddressLocation(data.label, data.zip);
          }
          if (data?.displayLabel) data.displayLabel = this.formatLocationLabel(data.displayLabel);
          if (data?.label && (data.type === 'zip' || data.type === 'country')) data.label = this.formatLocationLabel(data.label);
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(data));
          } catch (e) {}
          window.dispatchEvent(new CustomEvent('eurus:delivery-location:updated', { detail: data || {} }));
        },
        submitCountry(countryIso) {
          if (!this.countryInput || !countryIso || !this.form) return false;
          this.countryInput.value = countryIso;
          if (this.designMode) {
            this.countryIso = countryIso;
            window.dispatchEvent(new CustomEvent('eurus:delivery-location:updated', {
              detail: {
                countryIso,
                countryName: this.pendingLocation?.countryName || this.selectedCountryName || this.displayLocation
              }
            }));
            this.closeConfirm();
            this.showNudgeIfNeeded(700);
            return true;
          }
          this.form.submit();
          return true;
        },
        async lookupZip(zip) {
          const fiveDigitZip = zip.replace(/\D/g, '').slice(0, 5);
          if (!fiveDigitZip || fiveDigitZip.length < 5) return null;
          const cachedKey = `${this.storageKey}_zip_${fiveDigitZip}`;
          try {
            const cached = JSON.parse(localStorage.getItem(cachedKey) || '{}');
            if (cached.label) return this.formatLocationLabel(cached.label);
          } catch (e) {}

          try {
            const response = await fetch(`https://api.zippopotam.us/us/${fiveDigitZip}`, { method: 'GET' });
            if (!response.ok) return null;
            const data = await response.json();
            const place = data.places?.[0];
            const city = place?.['place name'];
            if (!city) return null;
            const label = this.formatLocationLabel(`${city} ${fiveDigitZip}`);
            try {
              localStorage.setItem(cachedKey, JSON.stringify({ label }));
            } catch (e) {}
            return label;
          } catch (e) {
            const fallbackLabel = this.formatZipLocation(fiveDigitZip);
            return fallbackLabel === `${this.usName} ${fiveDigitZip}` ? null : fallbackLabel;
          }
        },
        formatZipLocation(zip) {
          const fiveDigitZip = zip.replace(/\D/g, '').slice(0, 5);
          if (!fiveDigitZip) return '';
          const city = this.zipCityPrefixes[fiveDigitZip.slice(0, 3)] || this.usName;
          return this.formatLocationLabel(`${city} ${fiveDigitZip}`);
        },
        async applyZip() {
          const cleanZip = this.zip.replace(/\D/g, '').slice(0, 5);
          if (!cleanZip) return;
          this.zipLoading = true;
          this.zipMessage = '';
          const label = await this.lookupZip(cleanZip);
          this.zipLoading = false;
          if (!label) {
            this.zipMessage = 'Please enter a valid US ZIP code.';
            return;
          }
          this.pendingLocation = {
            type: 'zip',
            zip: cleanZip,
            label,
            countryIso: this.usIso,
            countryName: this.usName
          };
          this.displayLocation = label;
          this.selectedAddress = null;
          this.selectedAddressIndex = -1;
          this.selectedCountryIso = '';
          this.selectedCountryName = '';
          this.openConfirm(this.pendingLocation);
        },
        selectCountry(select) {
          const option = select.options[select.selectedIndex];
          if (!select.value || option?.disabled) return;
          this.selectedCountryIso = select.value;
          this.selectedCountryName = option?.dataset.countryName || option?.textContent?.trim() || '';
          this.selectedAddress = null;
          this.selectedAddressIndex = -1;
          this.pendingLocation = null;
        },
        selectAddress(index, label, countryIso, zip, countryName) {
          this.selectedAddressIndex = index;
          this.selectedAddress = { label, countryIso, zip, countryName };
          this.selectedCountryIso = '';
          this.selectedCountryName = '';
          this.pendingLocation = null;
        },
        selectAddressFromElement(el) {
          this.selectAddress(
            Number(el.dataset.addressIndex),
            el.dataset.addressLabel || '',
            el.dataset.addressCountry || this.countryIso,
            el.dataset.addressZip || '',
            el.dataset.addressCountryName || ''
          );
        },
        async buildAddressLocation(address) {
          const countryIso = address?.countryIso;
          const zip = address?.zip;
          const display = zip && countryIso === this.usIso ? await this.lookupZip(zip) : this.compactAddressLocation(address?.label, zip);
          return {
            type: 'address',
            label: address?.label || display || this.countryName,
            confirmLabel: this.stripAddressName(address?.label || display || this.countryName),
            displayLabel: this.formatLocationLabel(display || address?.label || this.countryName),
            countryIso: countryIso || this.countryIso,
            countryName: countryIso === this.usIso ? this.usName : (address?.countryName || this.countryName),
            zip
          };
        },
        compactAddressLocation(label, zip) {
          const cleanZip = (zip || '').toString().trim();
          const rawLabel = (label || '').toString();
          if (!cleanZip) return rawLabel;
          const beforeZip = rawLabel.split(cleanZip)[0] || '';
          const parts = beforeZip.split(',').map(part => part.trim()).filter(Boolean);
          const city = parts.length ? parts[parts.length - 1].split(/\s+/).slice(-2).join(' ') : '';
          return city ? this.formatLocationLabel(`${city} ${cleanZip}`) : cleanZip;
        },
        formatLocationLabel(value) {
          const label = (value || '').toString().trim();
          if (!label) return '';
          const match = label.match(/^(.*?)(\s+\d[\d\s-]*)$/);
          if (!match) return this.titleCaseLocationName(label);
          return `${this.titleCaseLocationName(match[1])}${match[2]}`;
        },
        titleCaseLocationName(value) {
          return (value || '').toString().toLocaleLowerCase('en-US').replace(/(^|[\s('/-])([a-z])/g, (match, prefix, letter) => `${prefix}${letter.toLocaleUpperCase('en-US')}`);
        },
        stripAddressName(label) {
          const value = (label || '').toString().trim();
          if (!value) return '';
          const firstComma = value.indexOf(',');
          if (firstComma > -1) {
            const beforeComma = value.slice(0, firstComma).trim();
            const afterComma = value.slice(firstComma + 1).trim();
            const parts = beforeComma.split(/\s+/).filter(Boolean);
            if (parts.length > 3 && afterComma) {
              return afterComma;
            }
          }
          const words = value.split(/\s+/).filter(Boolean);
          if (words.length > 4) {
            return words.slice(2).join(' ');
          }
          return value;
        },
        async done() {
          if (this.selectedAddress) {
            const location = await this.buildAddressLocation(this.selectedAddress);
            this.openConfirm(location);
            return;
          }
          if (this.pendingLocation) {
            this.openConfirm(this.pendingLocation);
            return;
          }
          if (!this.selectedCountryIso && this.$refs.countrySelect?.value) {
            this.selectCountry(this.$refs.countrySelect);
          }
          if (this.selectedCountryIso) {
            this.openConfirm({
              type: 'country',
              countryIso: this.selectedCountryIso,
              countryName: this.selectedCountryName,
              label: this.selectedCountryName
            });
            return;
          }
          this.close();
        },
        async continueWithLocation() {
          const location = this.pendingLocation;
          if (!location) {
            this.closeConfirm();
            return;
          }
          if (location.countryIso && location.countryIso !== this.countryIso) {
            await window.EurusUsOnlyCartGuard?.removeForCountry?.(location.countryIso);
            this.saveLocation(location);
            this.displayLocation = this.formatLocationLabel(location.displayLabel || location.label || this.displayLocation);
            this.submitCountry(location.countryIso);
            return;
          }
          this.saveLocation(location);
          this.displayLocation = this.formatLocationLabel(location.displayLabel || location.label || this.displayLocation);
          if (this.designMode && location.countryIso) {
            this.countryIso = location.countryIso;
            window.dispatchEvent(new CustomEvent('eurus:delivery-location:updated', { detail: location }));
          }
          this.closeConfirm();
          this.showNudgeIfNeeded(700);
        }
      }))
    });
  });
}

(() => {
  if (!window.EurusThemeEditorMode && !window.Shopify?.designMode) return;

  let previewCountryIso = '';

  const getStoredPreviewCountry = () => {
    try {
      for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i) || '';
        if (!key.startsWith('eurus_delivery_location_') || key.includes('_nudge') || key.includes('_zip')) continue;
        const value = JSON.parse(localStorage.getItem(key) || '{}');
        if (value?.countryIso) return value.countryIso;
      }
    } catch (e) {}
    return '';
  };

  const applyCountryPreview = () => {
    const countryIso = previewCountryIso || getStoredPreviewCountry();
    if (!countryIso) return;

    document.body?.setAttribute('data-eurus-preview-country', countryIso);

    document.querySelectorAll('[data-country-visibility]').forEach((element) => {
      const visibility = element.dataset.countryVisibility || 'all';
      const hideOutsideUs = element.dataset.hideOutsideUs === 'true';
      const wrapper = element.closest('.shopify-section') || element;
      const shouldHide =
        visibility === 'us_only' && countryIso !== 'US' ||
        visibility === 'outside_us' && countryIso === 'US' ||
        hideOutsideUs && countryIso !== 'US';

      wrapper.style.display = shouldHide ? 'none' : '';
    });
  };

  window.addEventListener('eurus:delivery-location:updated', (event) => {
    if (event.detail?.countryIso) previewCountryIso = event.detail.countryIso;
    requestAnimationFrame(applyCountryPreview);
  });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(applyCountryPreview));
  document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(applyCountryPreview));
  requestAnimationFrame(applyCountryPreview);
})();
